import { BsThreeDots as Dots, BsHeartFill as LikeActive, BsHeart as Like } from 'react-icons/bs';
import { FaRegComment as Comments, FaUser as Profile } from 'react-icons/fa';
import { FiUpload as Share, FiRepeat as Repost } from 'react-icons/fi';
import { AiOutlineFileGif as Gif, AiOutlineClose as Times } from 'react-icons/ai';
import {
   BsCardImage as Image, BsEmojiSmile as Smile, BsLink45Deg as Link, BsGeoAlt as Location,
   BsFillReplyAllFill as Reply, BsCameraFill as Camera
} from 'react-icons/bs';
import { GrTwitter as Twitter } from 'react-icons/gr';
import { IoMdAlert as Alert } from 'react-icons/io';
import { RiLogoutBoxLine as Out } from 'react-icons/ri';
import { FaRegCalendarAlt as Calendar } from 'react-icons/fa';
import { FcGoogle as Google } from 'react-icons/fc';

export const DotsIcon = Dots;
export const CommentsIcon = Comments;
export const LikeActiveIcon = LikeActive;
export const LikeIcon = Like;
export const ShareIcon = Share;
export const RepostIcon = Repost;
export const GifIcon = Gif;
export const ImageIcon = Image;
export const SmileIcon = Smile;
export const TwitterIcon = Twitter;
export const AlertIcon = Alert;
export const TimesIcon = Times;
export const LogoutIcon = Out;
export const ProfileIcon = Profile;
export const CalendarIcon = Calendar;
export const LocationIcon = Location;
export const LinkIcon = Link;
export const ReplyIcon = Reply;
export const CameraIcon = Camera;
export const GoogleIcon = Google;